/**
 * App config injected at build time from countries/<COUNTRY>.json
 * (see vite.config.js `define`). Falls back to sane defaults so the
 * module also works if the define is ever missing.
 */
/* global __APP_CONFIG__ */
const FALLBACK = {
  code: 'default',
  countryName: { ar: '', en: '' },
  defaultLang: 'ar',
  currency: '$',
  maxBet: 200,
  bonusAmount: '$100',
  affiliateLink: 'https://www.time4100.com/affiliates/?btag=2627677_l385022',
};

export const CONFIG =
  typeof __APP_CONFIG__ !== 'undefined' ? __APP_CONFIG__ : FALLBACK;

export const AFFILIATE_LINK = CONFIG.affiliateLink;
